// extracted by mini-css-extract-plugin
module.exports = {"root":"SoftwareAddresses_root__2HEDS","sameAddress":"SoftwareAddresses_sameAddress__DRt3P"};